import InventoryApi from "@/services/api/inventorytApi";
import ProductApi from "@/services/api/productApi";

const InventoryApiService = new InventoryApi(),
  ProductApiService = new ProductApi();

export const inventoryHelper = {
  methods: {
    updateAllProducts(trackedInventoryToAdd, untrackedInventoryToAdd) {
      InventoryApiService.setInventoryForProducts(trackedInventoryToAdd);
      untrackedInventoryToAdd.forEach(async (product) => {
        await this.updateProductStock(product);
      });
    },
    async updateProductStock(product) {
      const { data } = await ProductApiService.getProduct(product.product_id);
      data.track_inventory = false;
      data.variants.forEach((variant, i) => {
        const in_stock = product.variants[i].in_stock;
        variant.sku = product.variants[i].sku;
        variant.in_stock = in_stock;
        delete variant.inventory_quantity;
        Object.keys(variant).forEach((key) => {
          if (variant[key] === null) {
            delete variant[key];
          }
        });
      });
      data.images.forEach((image, i) => {
        data.images[i] = image.id;
      });
      data.category_ids = [];
      data.categories.forEach((image, i) => {
        data.category_ids[i] = image.id;
      });
      delete data.categories;
      Object.keys(data).forEach((key) => {
        if (data[key] === null) {
          delete data[key];
        }
      });
      delete data.video;
      await ProductApiService.updateProduct(data);
    },
  },
};
